import React, { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { ENTERED, ENTERING, EXITING } from 'react-transition-group/Transition';
const DURATION = 350;
const defaultStyle = {
    transition: `opacity ${DURATION}ms ease-in-out`,
    opacity: 0,
};
const transitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
};
export const FadeOut = ({ visible, children }) => {
    const nodeRef = useRef(null);
    return (React.createElement(Transition, { nodeRef: nodeRef, in: visible, timeout: DURATION }, (state) => (React.createElement("div", { ref: nodeRef, style: {
            ...defaultStyle,
            ...transitionStyles[state],
        } }, [ENTERING, ENTERED, EXITING].includes(state) ? children : null))));
};
//# sourceMappingURL=fade-out.js.map